export const ORGANIZE_BY = [
  // {
  //   label: "Date",
  //   value: "date",
  // },
  {
    label: "Job/Role",
    value: "job_role",
  },{
    label: "Date - Newest to oldest",
    value: "newest_to_oldest",
  },{
    label: "Date - Oldest to newest",
    value: "oldest_to_newest",
  },
];

export const DATE_NEWEST_TO_OLDEST = 'Newest to oldest';
export const DATE_OLDEST_TO_NEWEST = 'Oldest to newest';
export const JOB_ROLE = 'Job/Role';
export const ASCENDING_A_Z = 'Ascending(a-z)';
export const DESCENDING_Z_A = 'Descending(z-a)';
export const MOST_TO_LEAST = 'Most to Least';
export const LEAST_TO_MOST = 'Least to Most';
export const CUSTOM_ORDER = 'Custom Order';
export const DATE = 'Date';
export const CATEGORY = 'Category';
// export const TEMPLATE_NAME_1 = 'Classic Resume';
// export const TEMPLATE_NAME_2 = 'Marquee Resume';
// export const TEMPLATE_NAME_3 = 'Template Name 3';
// export const TEMPLATE_NAME_4 = 'Minimalist Resume';
// export const TEMPLATE_NAME_5 = 'Acting Resume';
export const TEMPLATE_NAME_1 = 'Template Name 1';
export const TEMPLATE_NAME_2 = 'Template Name 2';
export const TEMPLATE_NAME_3 = 'Template Name 3';
export const TEMPLATE_NAME_4 = 'Template Name 4';
export const TEMPLATE_NAME_5 = 'Template Name 5';

/**
 * ---------------------------------------------------------------------------
 * Resume bio limits
 * ---------------------------------------------------------------------------
 * The resume bio is seeded from the user's profile About section, which allows
 * far more text than any resume template can print. Each template has its own
 * ceiling, driven by the width of its bio box and the number of lines it clamps
 * to — so the limit belongs here, never inline in a component or a template.
 *
 * Counted in characters, measured in grapheme clusters (see utils/bio-limit).
 */
export const BIO_UNIT_CHARACTERS = 'characters';
export const BIO_UNIT_WORDS = 'words';

/** Unit every bio limit below is expressed in. */
export const RESUME_BIO_UNIT = BIO_UNIT_CHARACTERS;

/** What the profile About section allows, quoted back to the user in the note. */
export const PROFILE_ABOUT_LIMIT = 2000;

/** Fallback for a template not listed below. */
export const DEFAULT_RESUME_BIO_LIMIT = 500;

/**
 * Per-template ceilings. Template 5 (Acting) is the tight one: its bio sits in a
 * ~220px column clamped to 4 lines, so it holds far less than the others.
 */
export const RESUME_BIO_LIMITS = {
  [TEMPLATE_NAME_1]: 1000, // Classic
  [TEMPLATE_NAME_2]: 1000, // Marquee
  [TEMPLATE_NAME_3]: 500,  // dead placeholder
  [TEMPLATE_NAME_4]: 1000, // Minimalist
  [TEMPLATE_NAME_5]: 215,  // Acting — tight column, unchanged
};

/**
 * Shared character budget per template (MCF-637).
 *
 * Instead of each resume text box having its own ceiling, every template gets
 * ONE budget that is shared across all of its text boxes — the Bio plus the six
 * Professional Information fields (Abilities/Skills, Education, Training,
 * Experience, Awards, Representation). The sum of all of them cannot exceed the
 * number below, so the combined text always fits the page. Each box's counter
 * shows the same shared remaining count.
 *
 * Numbers are measured from the rendered layout (10px body, ~4.75px/char, 18px
 * line-height): chars-per-line × the comfortable number of body lines the
 * Bio+Professional column holds on one A4 page before it spills.
 *
 * Counted in characters (grapheme clusters, see utils/bio-limit).
 */
export const DEFAULT_RESUME_SHARED_BUDGET = 2000;

export const RESUME_SHARED_BUDGETS = {
  [TEMPLATE_NAME_1]: 2300, // Classic    — two-column, ~71 chars/line
  [TEMPLATE_NAME_2]: 2300, // Marquee    — two-column
  [TEMPLATE_NAME_3]: 2000, // dead placeholder
  [TEMPLATE_NAME_4]: 2500, // Minimalist — wider column, ~77 chars/line
  [TEMPLATE_NAME_5]: 1200, // Acting     — tight column
};

/**
 * The resume text boxes that draw from the shared budget, in the order the pool
 * drains. Earlier fields keep their text when the pool runs out; later fields
 * shade grey and drop from the preview/PDF first. Keys match the keys used in
 * the More Info panel state and the saved more_info payload.
 */
export const RESUME_SHARED_BUDGET_FIELDS = [
  "bio",
  "skills",         // Abilities / Skills / Specialties
  "education",
  "training",
  "experience",
  "awards",
  "representation",
];
